<template>
  <div>
    <section class="subpage-head">
      <div class="container">
        <h1>Login</h1>
      </div>
    </section>
    
    
    <section class="login-reg">
      <div class="container">
        <div class="log-box main">
          <form class="gen-form" v-if="!modeForgot" v-on:submit.prevent="doLogin">
            <div class="form-row">
              <label>Email:</label>
              <input type="text" name="username" v-model="username" required />
            </div>
            <div class="form-row">
              <label>Password:</label>
              <input type="password" name="password" v-model="password" required />
            </div>
            <div class="form-row split">
              <label class="checkbox">
                <input type="checkbox" v-model="rememberme" />
                <em></em>
                <span>Remember me</span>
              </label>
              <a href="" v-on:click.prevent="modeForgot=1">Forgot password?</a>
            </div>
            <div class="form-act">
              <button class="lbtn">Login</button>
            </div>
          </form>
          <form class="gen-form" v-else-if="modeForgot==1" v-on:submit.prevent="doForgot">
            <div class="form-row">
              <label>Email:</label>
              <input type="text" v-model="username" />
            </div>
            <div class="form-act">
              <button class="lbtn">Send reset code</button>
            </div>
          </form>
          <form class="gen-form" v-else-if="modeForgot==2" v-on:submit.prevent="doReset">
            <div class="form-row">
              <label>Email:</label>
              <input type="text" v-model="username" required />
            </div>
            <div class="form-row">
              <label>Reset code:</label>
              <input type="text" v-model="resetCode" required />
            </div>
            <div class="form-row">
              <label>New Password:</label>
              <input type="password" v-model="password" required />
            </div>
            <div class="form-row">
              <label>Confirm Password:</label>
              <input type="password" v-model="passwordConfirm" required />
            </div>
            <div class="form-row split">
              <label class="checkbox">
                <input type="checkbox" v-model="rememberme" />
                <em></em>
                <span>Remember me</span>
              </label>
            </div>
            <div class="form-act">
              <button class="lbtn">Reset password and Login</button>
            </div>
          </form>
        </div>
        <div class="log-box sec register-banner">
          <div class="reg-title">Don't have an account yet?</div>
<!--          <ul class="reg-list">
            <li>individual video</li>
            <li>Private Videos</li>
            <li>Videos per group</li>
            <li>Questionare</li>
            <li>and more</li>
          </ul>-->
          <div class="reg-act">Join now!</div>
          <div class="form-act">
            <router-link :to="{name: 'user.register'}" class="lbtn">Register</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import api from './api';
export default {
  data: ()=>({
    modeForgot: false,
    expiryPeriodPercent: 25,
    username: "",
    password: "",
    resetCode: "",
    passwordConfirm: "",
    rememberme: false,
    register: {},
  }),
  methods: {
    async doLogin() {
      var result=await api.login(this.username, this.password, this.rememberme);
      if (result.success) {
        this.$router.push({name: "home"});
      } else
        alert("Your username or password do not match your subscription details. Please try again.");
    },
    async doForgot() {
      var result=await api.login(this.username, '', false, 'forgot');
      this.modeForgot=2;
    },
    async doReset() {
      if (this.password!=this.passwordConfirm)
        return alert("Your new and confirmed password do not match.");
      var result=await api.login(this.username, this.password, this.rememberme, this.resetCode);
      if (result.success) {
        this.modeForgot=null;
        this.$parent.currentPane=null;
        this.$router.push({name: "home"});
      } else
        alert("Your username or reset code are not correct. Please try again.");
    },
  },
  async created() {
    if (window.userData) {
      this.username=window.userData.username;
      this.password=window.userData.password;
      window.userData=undefined;
    }
  },
  async mounted() {
    if (location.hash && location.hash.length>=8) {
      var username=location.hash.replace(/^#|&.*/g, "");
      var code=location.hash.replace(/^[^&]*&/g, "");
      this.modeForgot=2;
      this.username=username;
      this.resetCode=code;
    }
  },
}
</script>
